import { familyTypes } from 'src/lib/constants'

// A community plan id is interpolated into an /edit-plan/:id link, so it is
// external input reaching a URL sink. Allow only the id character set the BFF
// issues and reject anything else — a value such as 'https://evil.example.com/x'
// must never be turned into a link.
const COMMUNITY_PLAN_ID_PATTERN = /^[A-Za-z0-9*+_-]{1,64}$/

/** True when a plan id is safe to interpolate into an /edit-plan link. */
export const isLinkableCommunityPlanId = (planId?: string): planId is string =>
  typeof planId === 'string' && COMMUNITY_PLAN_ID_PATTERN.test(planId)

/**
 * URL that opens a regional-approval DRAFT plan (always single-family) in the
 * intake form. Callers must gate on {@link isLinkableCommunityPlanId} first so a
 * malformed id never reaches the link.
 */
export const buildRegionalDraftPlanUrl = (draftPlanId: string): string =>
  `/edit-plan/${draftPlanId}/draft?familyType=${familyTypes.SINGLE}`

/**
 * URL that opens an Approved Regional Plan (submitted, single-family) in the
 * intake form, where it is view-only. Callers must gate on
 * {@link isLinkableCommunityPlanId} first so a malformed id never reaches the link.
 */
export const buildApprovedRegionalPlanUrl = (sourcePlanId: string): string =>
  `/edit-plan/${sourcePlanId}/submit?familyType=${familyTypes.SINGLE}`
